module.exports = __webpack_public_path__ + "2506682a9d295adc26fe8411ba735046.pdf";